const Window = ({
  trait,
  handleTraitChange,
  window,
  number,
  windowID,
  sectionColor,
}) => {
  return (
    <div>
      <div className="col" id="form-windows">
        <div className="my-1 py-2">
          <p
            style={{
              textAlign: "center",
              color: "white",
              background: sectionColor,
            }}
          >
            {number}
          </p>
        </div>
        <div className="windowWH">
          <div id="form-windows">
            <input
              id={windowID}
              disabled={!window.windowType}
              className="form-control mb-3"
              type="number"
              name="windowW"
              min="24"
              max="42"
              defaultValue={
                !window.windowType || window.windowW > 42 * trait.pixels
                  ? "42"
                  : window.windowW / trait.pixels
              }
              onChange={(e) => handleTraitChange(e)}
            ></input>
          </div>
          <p> x </p>
          <div id="form-windows">
            <input
              id={windowID}
              step=".5"
              className="form-control mb-3"
              type="number"
              name="windowH"
              defaultValue={window.windowH / trait.pixels}
              onChange={(e) => handleTraitChange(e)}
            ></input>
          </div>
        </div>

        <label>Tempered</label>
        <select
          id={windowID}
          name="tempered"
          className="form-control mb-3"
          onChange={(e) => handleTraitChange(e)}
          defaultValue={window.tempered}
        >
          <option value="STANDARD">NO</option>
          <option value="TEMPERED">TEMPERED</option>
        </select>
        <label>Type</label>
        <select
          id={windowID}
          name="windowType"
          className="form-control mb-3"
          onChange={(e) => handleTraitChange(e)}
          defaultValue={window.windowType}
        >
          <option value="FIXED">FIXED</option>
          <option value="SINGLE HUNG">SINGLE HUNG</option>
          <option value="DOUBLE HUNG">DOUBLE HUNG</option>
          <option value="SLIDER">SLIDER</option>
          <option value="AWNING">AWNING</option>
          <option value="CASEMENT">CASEMENT</option>
        </select>
        <label>Placement</label>
        <select
          id={windowID}
          defaultValue={window.placement / trait.pixels}
          name="placement"
          className="form-control mb-3"
          onChange={(e) => handleTraitChange(e)}
          disabled={!window.windowType}
        >
          <option value="0">CENTER</option>
          <option value="1">LEFT</option>
          <option value="2">RIGHT</option>
        </select>

        <label>Header</label>
        <select
          id={windowID}
          defaultValue={window.header / trait.pixels}
          className="form-control mb-3"
          type="number"
          name="header"
          onChange={(e) => handleTraitChange(e)}
        >
          <option value="5.5">2 x 6</option>
          <option value="7.25">2 x 8</option>
          <option value="9.25">2 x 10</option>
          <option value="11.25">2 x 12</option>
        </select>

        <label>Sill</label>
        <input
          id={windowID}
          defaultValue={window.sill / trait.pixels}
          className="form-control mb-3"
          type="number"
          name="sill"
          step=".5"
          min="10"
          onChange={(e) => handleTraitChange(e)}
        ></input>
        <label>Header Amount</label>
        <select
          id={windowID}
          defaultValue={window.headerAmount / trait.pixels}
          className="form-control mb-3"
          type="number"
          name="headerAmount"
          onChange={(e) => handleTraitChange(e)}
        >
          <option value="3">NONE</option>
          <option value="0">SINGLE</option>
          <option value="1">DOUBLE</option>
          <option value="2">TRIPLE</option>
        </select>
      </div>
    </div>
  );
};

export default Window;
